import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import {useTranslation} from 'react-i18next';
import {loginUser} from '@store/reducers/auth';
import {Checkbox, Button, Input} from '@components';
import {faUser, faLock} from '@fortawesome/free-solid-svg-icons';

import * as Yup from 'yup';

import * as AuthService from '../../services/auth';

const Login = () => {
    const [isAuthLoading, setAuthLoading] = useState(false);
    const [isGoogleAuthLoading, setGoogleAuthLoading] = useState(false);
    const [isFacebookAuthLoading, setFacebookAuthLoading] = useState(false);
    const dispatch = useDispatch();

    const history = useHistory();
    const [t] = useTranslation();

    const login = async (email, password) => {
        try {
            setAuthLoading(true);
            const token = await AuthService.loginByAuth(email, password);
            toast.success('Iniciaste sesión');
            setAuthLoading(false);
            dispatch(loginUser(token));
            history.push('/');
        } catch (error) {
            setAuthLoading(false);
            toast.error(error.message || 'Failed');
            throw Error('Noou');
        }
    };

    const formik = useFormik({
        initialValues: {
            username: '',
            password: ''
        },
        validationSchema: Yup.object({
            username: Yup.string()
                .required('Obligatorio'),
            password: Yup.string()
                .required('Obligatorio')
        }),
        onSubmit: (values, {setFieldError}) => {
            login(values.username, values.password).then(()=>{}).catch(e => {
                setFieldError('username','Datos incorrectos');
                setFieldError('password','Datos incorrectos');
            });
        }
    });

    document.getElementById('root').classList = 'hold-transition login-page';

    return (
        <div className="login-box">
            <div className="card card-outline card-primary">
                <div className="card-header text-center">
                    <Link to="/" className="h1">
                        <img src="/img/logo/x189.png"></img>
                    </Link>
                </div>
                <div className="card-body">
                    <p className="login-box-msg"><b>Telinfor Management Web</b> | {t('login.label.signIn')}</p>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="mb-3">
                            <Input
                                icon={faUser}
                                placeholder="Correo o usuario"
                                type="text"
                                formik={formik}
                                formikFieldProps={formik.getFieldProps('username')}
                            />
                        </div>
                        <div className="mb-3">
                            <Input
                                icon={faLock}
                                placeholder="Contraseña"
                                type="password"
                                formik={formik}
                                formikFieldProps={formik.getFieldProps(
                                    'password'
                                )}
                            />
                        </div>

                        <div className="row">
                            <div className="col-8">
                                <Checkbox
                                    checked={false}
                                    label={t('login.label.rememberMe')}
                                />
                            </div>
                            <div className="col-4">
                                <Button
                                    block
                                    type="submit"
                                    isLoading={isAuthLoading}
                                    disabled={
                                        isFacebookAuthLoading ||
                                        isGoogleAuthLoading
                                    }
                                >
                                    {t('login.button.signIn.label')}
                                </Button>
                            </div>
                        </div>
                    </form>
                    <p className="mb-1">
                        <Link to="/forgot-password">
                            {t('login.label.forgotPass')}
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Login;
